import { Component, Input, ViewChild } from "@angular/core";
import { NgModel, FormsModule } from "@angular/forms";
import { EmailModel } from "@app/shared/components/email/email.model";
import { ValidationMessageComponent } from "../validation/validation-message.component";
import { ValidationMessagesComponent } from "../validation/validation-messages.component";
import { MailValidator } from "../../directives/mail/mail.validator";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { MatInput } from "@angular/material/input";
import { GtmChangeDirective } from "../../directives/gtm-form-event/gtm-change.directive";
import { NgIf } from "@angular/common";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { ProvideParentFormDirective } from "../../directives/provide-parent-form/provide-parent-form.directive";

@Component({
  selector: "app-email",
  templateUrl: "./email.component.html",
  standalone: true,
  imports: [
    ProvideParentFormDirective,
    MatFormField,
    MatLabel,
    NgIf,
    GtmChangeDirective,
    MatInput,
    NgxTrimDirectiveModule,
    FormsModule,
    MailValidator,
    MatError,
    ValidationMessagesComponent,
    ValidationMessageComponent
  ]
})
export class EmailComponent {
  @Input() modelRef: EmailModel;
  @Input() requiredField: boolean;
  @Input() redStar: boolean;
  @Input() id: string;
  @ViewChild("email", { static: true }) email: NgModel;
}
